/* istanbul ignore file */
import { apiGet } from '../../../utilities/utils';
import actionTypes from '../../../actions/actionTypes';
import store from '../../../store';
import actions from '../../../actions';

export function setIsLoading(loading) {
	store.dispatch({
		type: actionTypes.IS_LOADING,
		payload: loading,
	});
}

// export const searchConceptsById = (conceptIds) => {
// 	return new Promise((resolve, reject) => {
// 		store
// 			.dispatch(actions.searchConceptsById(conceptIds))
// 			.then((resp) => {
// 				resolve(resp);
// 			})
// 			.catch((err) => {
// 				reject(err);
// 			});
// 	});
// };
export function searchConceptsById(conceptIds, eventIds) {
	return new Promise(function (resolve, reject) {
		let params = {};
		params['conceptTableEntry.umls_concept_category'] = 'All';
		if (conceptIds) {
			params['conceptIds'] = conceptIds;
		}
		if (eventIds) {
			params['eventIds'] = eventIds;
		}
		apiGet('SearchConceptsById', params)
			.then((res) => {
				store.dispatch({
					type: actionTypes.GET_STUDY_CONCEPTS,
					payload: res.data.data,
				});
				resolve(res.data.data);
			})
			.catch((err) => {
				reject(err);
			});
	});
}

export function getConceptSupportDataForDocument(dataRecordId, m_conceptId) {
	return new Promise(function (resolve, reject) {
		apiGet('GetConceptSupportDataForDocument', {
			dataRecordId,
			m_conceptId,
		})
			.then((res) => {
				resolve(res);
			})
			.catch((err) => {
				console.log(err);
				reject(err);
			});
	});
}
